import { type Subcategory, getSubcategory } from '~/entities/categories'
import type { apiClient } from '~/shared/api/data-ingestion-api'
import type { ClassificationEventProps } from '../../model'
import type { EventMeta } from '../pre-pass'

export function transformClassification(
  event: apiClient.AuditEvent,
  meta: EventMeta,
  subcategories: Subcategory[],
): ClassificationEventProps {
  const isClassificationEvent = event.event_type === 'class' || event.event_type === 'mbclass'

  const title = isClassificationEvent
    ? 'Classification: Classified'
    : meta.classificationRevalidated
      ? 'Classification: Asset revalidated'
      : 'Classification: Asset validated'

  let descriptionText: string | null = null
  if (event.category) {
    const subcategory = getSubcategory({ category: event.category, subcategories })
    if (subcategory) {
      descriptionText = isClassificationEvent
        ? `Classified as ${subcategory.displayLabel}`
        : `Validated as ${subcategory.displayLabel}`
    }
  }

  // Add source info for classification events
  let source: string | null = null
  if (event.event_type === 'class') {
    source = 'LLM'
  } else if (event.event_type === 'mbclass') {
    source = 'BERT'
  }

  return {
    type: 'classification',
    timestamp: event.timestamp,
    user: event.user,
    userRole: event.user ? 'person' : 'opti',
    step: 'classification',
    eventType: event.event_type,
    title,
    descriptionText,
    source,
    notes: event.notes ?? null,
  }
}

export function getClassificationSearchableText(props: ClassificationEventProps): string {
  const parts = [props.title]
  if (props.descriptionText) parts.push(props.descriptionText)
  if (props.source) parts.push(`Source: ${props.source}`)
  if (props.notes) parts.push(props.notes)
  return parts.join(' ')
}
